import Ajv from 'ajv'

export const validateSchema = (schema) => {
  const ajv = new Ajv({ allErrors: true })
  return ajv.compile(schema)
}
